import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//TODO: refactor form/valdiation handling; https://azuredevops.at.zurich.com/Zurich/DiTRo/_workitems/edit/51825/?workitem=94208
import { InputAdornment } from '@mui/material';
import { deAT, enUS } from 'date-fns/locale';
import { forwardRef, useEffect, useState, } from 'react';
import { useTranslation } from '@zurich/common/hooks';
import { styled } from '../../utils';
import { Dialog } from '../Dialog';
import { IconButton } from '../IconButton';
import { TextField } from '../TextField';
import { DateRangePicker } from './picker';
import { geDateRangeToMuiPickerDateRange, getDefaultRanges, isValidGeDateRange, muiPickerDateRangeToGeDateRange, } from './util';
export const ApiDateRangePicker = forwardRef(function ApiDateRangePicker(props, _ref) {
    const { disabled, onChange, required, helperText, error, onlyPast, label, value, onBlur, icon = 'calendar-2', } = props;
    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState(value ?? '');
    const [formatError, setFormatError] = useState(false);
    const [invalidDateRange, setInvalidDateRange] = useState(false);
    const generalError = formatError || invalidDateRange || !isValidGeDateRange(inputValue);
    const { t, i18n } = useTranslation();
    // If value present and not the right format - set error
    useEffect(() => {
        setFormatError(!!inputValue && !isValidGeDateRange(inputValue));
        const dateRange = geDateRangeToMuiPickerDateRange(inputValue);
        if (dateRange?.endDate &&
            dateRange?.startDate &&
            dateRange?.endDate < dateRange?.startDate) {
            setInvalidDateRange(true);
        }
        else {
            setInvalidDateRange(false);
            setInputValue(value || '');
        }
    }, [inputValue, value]);
    const toggle = () => {
        if (!disabled) {
            setOpen(!open);
        }
    };
    const onInputChange = (e) => {
        setInputValue(e.target?.value);
        const isInvalid = formatError || invalidDateRange || !isValidGeDateRange(e.target?.value);
        onChange?.(e.target?.value, !isInvalid);
    };
    const onDatePickerSelection = (dateRange) => {
        const formattedRange = muiPickerDateRangeToGeDateRange(dateRange);
        if (formattedRange) {
            setInputValue(formattedRange);
        }
        if (onChange) {
            const isInvalid = invalidDateRange || !isValidGeDateRange(formattedRange);
            onChange(formattedRange, !isInvalid);
        }
        if (onBlur) {
            onBlur(muiPickerDateRangeToGeDateRange(dateRange));
        }
        setOpen(false);
    };
    const reset = () => {
        setInputValue('');
        if (onChange) {
            onChange('', !generalError);
        }
        if (onBlur) {
            onBlur('');
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { label: label ?? 'Von - bis', onChange: onInputChange, onBlur: () => {
                    if (onBlur && !formatError) {
                        onBlur(inputValue);
                    }
                    if (!onBlur && onChange) {
                        onChange(inputValue, !generalError);
                    }
                }, value: inputValue ?? '', InputProps: {
                    endAdornment: (_jsxs(InputAdornment, { position: "end", sx: {
                            gap: '2.5px',
                        }, children: [value && (_jsx(IconButton, { disabled: disabled, onClick: reset, size: "small", variant: "close" })), _jsx(DateIconButtonStyled, { disabled: disabled, onClick: toggle, size: "small", variant: icon })] })),
                }, disabled: disabled, error: !!formatError || !!error || !!invalidDateRange, required: required, helperText: formatError
                    ? 'Format: "TT.MM.JJJJ - TT.MM.JJJJ"'
                    : invalidDateRange
                        ? 'Das Startdatum darf nicht nach dem Enddatum liegen.'
                        : helperText }), _jsx(DialogStlyed, { open: open, onClose: () => setOpen(false), children: _jsx(DateRangePicker, { open: open, toggle: toggle, locale: i18n.language === 'de' ? deAT : enUS, definedRanges: getDefaultRanges(t, onlyPast), initialDateRange: geDateRangeToMuiPickerDateRange(inputValue), onChange: onDatePickerSelection, maxDate: onlyPast ? new Date() : undefined }, inputValue) })] }));
});
const DialogStlyed = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        padding: 0,
    },
    '& .MuiDialogContent-root': {
        padding: 0,
    },
    '& .MuiInput-underline': {
        borderBottom: `1px solid ${theme.palette.primary.dark}`,
    },
    '& .MuiInput-underline::before': {
        borderBottom: `1px solid ${theme.palette.primary.dark}`,
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottom: `2px solid ${theme.palette.primary.dark}`,
    },
    '& [class*="materialui-daterange-picker-header"]': {
        // Upper region with selected dates
        backgroundColor: theme.palette.primary.dark,
        '& h6': {
            color: theme.palette.white.main,
        },
    },
    '& [class*="materialui-daterange-picker-headerItem"] svg': {
        // Arrow in the upper region
        color: theme.palette.white.main,
    },
    '& button[class*="materialui-daterange-picker-filled"]': {
        backgroundColor: theme.palette.primary.main,
    },
    '& [class*="materialui-daterange-picker-highlighted"]': {
        backgroundColor: theme.palette.groupPrimary.lightDove,
    },
}));
const DateIconButtonStyled = styled(IconButton)(() => ({
    '& .material-icons': {
        fontSize: 20,
    },
}));
